module.exports = "/packs/images/products/mint-640459553ea00c27aa3a39ee734df6ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/javascript/images/products/mint.jpg
// module id = 736
// module chunks = 0 1 2 4